import { createFileRoute } from "@tanstack/react-router";
import SubprocessorsPage from "@/pages/security/SubprocessorsPage";

export const Route = createFileRoute("/security/subprocessors")({
  component: SubprocessorsPage,
});
